import { render, staticRenderFns } from "./docpack_new.vue?vue&type=template&id=7cefdc45&scoped=true&"
import script from "./docpack_new.vue?vue&type=script&lang=js&"
export * from "./docpack_new.vue?vue&type=script&lang=js&"
import style0 from "./docpack_new.vue?vue&type=style&index=0&id=7cefdc45&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cefdc45",
  null
  
)

export default component.exports